import { createSelectorHook } from 'react-redux';
import { ensure } from '../../../utils/type-utils';
import { RootState } from '../reducer';
import { SettingsKey } from '../settings';

export const useSelector = createSelectorHook<RootState>();

export const useSettingsSelector = <T extends string | number>(key: SettingsKey) =>
  useSelector((state) => ensure(state.settings.values.find((setting) => setting.key === key)).value as T);
